// Visual Free Gift Display Logic - Cart Drawer Only
// Lightweight version without global fetch/XHR interception
//
// NOTE: Threshold is configured in snippets/visual-free-gift.liquid
// Update free_gift_threshold_bodywash variable there to change the threshold
//
// Fallback threshold (in paise) - only used if Liquid variable not set
// This should match the value in snippets/visual-free-gift.liquid
const free_gift_threshold_bodywash = 89800; // ₹898

window.VisualFreeGift = window.VisualFreeGift || (function() {
  let isInitialized = false;

  function updateVisualFreeGift() {
    const freeGiftCard = document.getElementById('visual-free-gift-card');
    if (!freeGiftCard) {
      return;
    }

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Use threshold from Liquid (preferred) or fallback to default
        const threshold = window.FREE_GIFT_THRESHOLD || free_gift_threshold_bodywash;

        if (cart.total_price >= threshold) {
          freeGiftCard.classList.add('show');
        } else {
          freeGiftCard.classList.remove('show');
        }
      })
      .catch(error => console.error('Free gift update error:', error));
  }

  function init() {
    if (isInitialized) {
      return;
    }
    isInitialized = true;

    // Initial update
    updateVisualFreeGift();
  }

  // Public API
  return {
    init: init,
    update: updateVisualFreeGift
  };
})();
